export const EN_LANG = "en-GB";

export const CACHE_DURATION_MS = window.APP_SETTINGS.localizationCacheDurationSeconds * 1000;
export const CHECK_LOCALIZATION_VERSION_URL = "version";
